import { lazy, Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import './App.scss'
import './shared/unScopedStyles.scss'
import ErrorBoundaries from './components/ErrorFallback/ErrorFallback'
import LoadingSpinner from './components/LoadingSpinner/LoadingSpinner'
import './firebase/configs'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from './redux/store'
// import createTheme from '@mui/material/styles/createTheme'
// import ThemeProvider from '@mui/material/styles/ThemeProvider'

import { setErrorMsg } from './redux/uiSlice'
// import DocumentMeta from "react-document-meta";
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
// @ts-ignore;
import UserAlert from './components/AlertComponent/UserAlert'
import { theme } from './shared/theme'
import { routes } from './routers/routes_v2'
import { logger } from './helpers/logger'
import { CssBaseline } from '@mui/material'
import CacheBuster from 'react-cache-buster'
import packageJson from '../package.json'

const ReactQueryDevtools =
    process.env.NODE_ENV === 'development'
        ? lazy(() =>
              import('@tanstack/react-query-devtools').then((module) => ({
                  default: module.ReactQueryDevtools,
              }))
          )
        : null

function App() {
    logger.debug('app rendered')
    const isProduction = process.env.NODE_ENV === 'production'
    const currentVersion = process.env.REACT_APP_VERSION || packageJson.version
    // process.env.REACT_APP_VERSION || packageJson.version

    return (
        <CacheBuster
            currentVersion={currentVersion}
            isEnabled={isProduction}
            isVerboseMode={false}
            loadingComponent={
                <LoadingSpinner fillViewPortHeight fillViewPortWidth />
            }
            metaFileDirectory={'.'}
            reloadOnDowngrade
        >
            <StyledEngineProvider injectFirst>
                <div
                    className="App"
                    style={{ position: 'relative', overflow: 'hidden' }}
                >
                    <ErrorBoundaries>
                        <ThemeProvider theme={theme}>
                            {/* <SessionTimeout/> */}
                            <CssBaseline />
                            <GlobalAlert />
                            <Suspense
                                fallback={
                                    <LoadingSpinner
                                        fillViewPortHeight
                                        fillViewPortWidth
                                    />
                                }
                            >
                                <RouterProvider router={routes} />
                            </Suspense>
                            {ReactQueryDevtools ? (
                                <Suspense fallback={null}>
                                    <ReactQueryDevtools />
                                </Suspense>
                            ) : null}
                        </ThemeProvider>
                    </ErrorBoundaries>
                </div>
            </StyledEngineProvider>
        </CacheBuster>
    )
}

const GlobalAlert = () => {
    const dispatch = useDispatch()
    const errorMsg = useSelector((state: RootState) => state.ui.errorMsg)

    if (errorMsg === undefined) return null
    if (typeof errorMsg === 'string') {
        return (
            <UserAlert
                open={true}
                content={errorMsg}
                id="global-alert-dialog"
                handleClose={() => dispatch(setErrorMsg(undefined))}
            />
        )
    }
    return (
        <UserAlert
            open={true}
            title={errorMsg.title}
            content={errorMsg.desc}
            id="global-alert-dialog"
            handleClose={() => dispatch(setErrorMsg(undefined))}
        />
    )
}

export default App
